import React, { useMemo } from "react";

import { HeaderSectionWrap } from "./catalogue.styles";
import PlainSearchInput from "../../../../../../library/SearchInput/PlainSearch";
import FilterDropdown from "../../../../../../library/filterDropdown";

const HeaderSection = ({
    searchString,
    setSearchString,
    catalogueItems,
    handleFilterByCategory,
}) => {
    const uniqueCategories = useMemo(
        () => [...new Map(catalogueItems?.map((item) => [item.category?.id, item])).values()],
        [catalogueItems],
    );

    const filterItems = useMemo(
        () =>
            uniqueCategories
                ?.map((item) => ({
                    name: item.category?.name,
                    id: item.category?.id,
                }))
                .filter((item) => item.name),
        [uniqueCategories],
    );

    return (
        <HeaderSectionWrap>
            <FilterDropdown
                initialName="All Items"
                filterItems={[{ name: "All Items", id: 0 }, ...filterItems]}
                handleFilteredClick={handleFilterByCategory}
            />
            <PlainSearchInput placeholder={"Search Item"} {...{ searchString, setSearchString }} />
        </HeaderSectionWrap>
    );
};

export default HeaderSection;
